'use strict';

wbApp.controller('ProtectedStorageCtrl', ['$scope', '$modal', '$q', '$http', '$translate', 'messageBoxSvc', 'protectedStorageSvc',
    function ($scope, $modal, $q, $http, $translate, messageBoxSvc, protectedStorageSvc) {

    $scope.$on('refreshData', function (e, data) {
        if (fileManagerInstance) {
            fileManagerInstance.refresh();
        }
    });

    function downloadDataUrlFromJavascript(name, dataUrl) {
        var link = document.createElement("a");       
        link.target = "_blank";
        link.setAttribute("download", name);
        link.href = dataUrl;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    }

    var chunkSize = 1024 * 1024 * 8;   // 8 MB

    var contextMenuItems = [
        "delete",
        {
            name: "make-public",
            text: $translate.instant('TXT_LBL_CHANGE_TO_PUBLIC'),
            icon: "warning",
            beginGroup: true
        },
        {
            name: "make-private",
            text: $translate.instant('TXT_LBL_CHANGE_TO_PRIVATE'),
            icon: "key",
            beginGroup: true
        },
        {
            name: "get-download-url",
            text: $translate.instant('TXT_LBL_SHOW_PUBLIC_URL'),
            icon: "link",
        },
        "refresh",
        "download"
    ];

        function onShowDirectJoinLink(downloadUrl) {
            messageBoxSvc.showMessageDlg({
                title: 'TXT_PUBLIC_URL',
                message: '<a href="{0}" target="_blank">{0}</a>'.f(encodeURI(downloadUrl)),
                buttons: [{
                    text: 'TXT_BTN_OK'
                }]
            });
        }

        function onItemClick(args) {

            var selectedItems = fileManagerInstance.getSelectedItems();
            if (!!selectedItems && selectedItems.length > 0) {

                if (args.itemData.name === "make-public") {
                    protectedStorageSvc.setPublicAccess(selectedItems[0].path, true).$promise.then(function () {
                        fileManagerInstance.refresh();
                    });
                }
                if (args.itemData.name === "make-private") {
                    protectedStorageSvc.setPublicAccess(selectedItems[0].path, false).$promise.then(function () {
                        fileManagerInstance.refresh();
                    });
                }
                if (args.itemData.name === "get-download-url") {
                    protectedStorageSvc.getDownloadUrl(selectedItems[0].path).$promise.then(function (downloadUrl) {
                        onShowDirectJoinLink(downloadUrl.url);
                    });                    
                }
            }
        }

    var fileManagerInstance;
    $scope.fileManagerOptions = {
        fileSystemProvider: new DevExpress.fileManagement.CustomFileSystemProvider({
            getItems: function(pathInfo) {
                return protectedStorageSvc.getDirectory(pathInfo.path).$promise;
            },
            downloadItems: function (items) {
                protectedStorageSvc.getDownloadUrl(items[0].path).$promise.then(function (downloadUrl) {
                    downloadDataUrlFromJavascript(items[0].name, downloadUrl.url);
                });
            },
            createDirectory: function (parentDir, name) {                
                return protectedStorageSvc.createDirectory(!!parentDir.path ? parentDir.path + "/" + name : name).$promise;
            },
            deleteItem: function(item) {
                if (item.isDirectory)
                {
                    return protectedStorageSvc.deleteDirectory(item.path).$promise;
                }
                else
                {
                    return protectedStorageSvc.deleteFile(item.path).$promise;
                }
            },
            uploadFileChunk: function (fileData, uploadInfo, destinationDirectory) {

                var fileSize = fileData.size;
                var contentType = fileData.type;
                var chunkCount = uploadInfo.chunkCount;

                var deffered = $q(function (resolve, reject) {
                    if (uploadInfo.chunkIndex === 0) {
                        var filePath = destinationDirectory.path ? destinationDirectory.path + "/" + fileData.name : fileData.name;
                        protectedStorageSvc.getUploadUrl(filePath, contentType).$promise.then(function (uploadUrl) {
                            uploadInfo.customData.accessUrl = uploadUrl.url;
                            resolve();
                        });
                    }
                    else {
                        resolve();
                    }
                });

                return $q(function (resolve, reject) {
                    deffered.then(function () {

                        var chunkSize = uploadInfo.chunkBlob.size;
                        var chunkFirstByte = uploadInfo.bytesUploaded;
                        var chunkLastByte = uploadInfo.bytesUploaded + uploadInfo.chunkBlob.size - 1;
                        var totalObjectSize = fileSize;

                        $.ajax({
                            url: uploadInfo.customData.accessUrl,
                            type: 'PUT',
                            contentType: contentType,
                            contentLength: uploadInfo.chunkBlob.size,
                            headers: {
                                'Content-Range': "bytes " + chunkFirstByte + "-" + chunkLastByte + "/" + fileSize
                            },
                            data: uploadInfo.chunkBlob,
                            crossDomain: true,
                            processData: false,
                            success: function (res) {
                                resolve();
                            },
                            error: function (err) {
                                if (err.status == 308) { // Continue with next chunk    
                                    resolve();
                                } else {
                                    reject(err);
                                }
                            }
                        });
                    });
                });
            },
            contentExpr: "contentType",
            dateModifiedExpr: "createdAtUtc"
        }),
        permissions: {
            download: true,
            create: true,
            delete: true,
            upload: true
        },
        selectionMode: "single",
        upload: {
            maxFileSize: (1024 * 1024) * 1024 * 1204 * 5, // 5 TB GCS object limit
            chunkSize: chunkSize   
        },
        onContentReady: function (e) {
            fileManagerInstance = e.component;
        },
        onSelectionChanged: function (e) {
            if (!!e.selectedItems && e.selectedItems.length > 0) {
                var isDirectory = e.selectedItems[0].dataItem.isDirectory;
                var isPublic = e.selectedItems[0].dataItem.isPublic;

                if (isDirectory) {
                    e.component.option('contextMenu.items', contextMenuItems.filter(item => {
                        if (item === 'delete' || item === 'refresh') {
                            return item;
                        }
                    }));
                } else if (isPublic) {
                    e.component.option('contextMenu.items', contextMenuItems.filter(item => {
                        if (item === 'delete' || item === 'refresh' || item === "download" ||
                            item.name === "make-private" || item.name === "get-download-url") {
                            return item;
                        }
                    }));
                } else {
                    e.component.option('contextMenu.items', contextMenuItems.filter(item => {
                        if (item === 'delete' || item === 'refresh' || item === "download" || item.name === "make-public") {
                            return item;
                        }
                    }));
                }
            } else {
                e.component.option('contextMenu.items', contextMenuItems.filter(item => {
                    if (item === 'refresh') {
                        return item;
                    }
                }));
            }
        },
        contextMenu: {
            items: contextMenuItems
        },
        onContextMenuItemClick: onItemClick,
        itemView: {
            details: {
                columns: [
                    "thumbnail",
                    "name",
                    {
                        dataField: "isPublic",
                        caption: $translate.instant('TXT_LBL_PUBLIC'),
                        dataType: "boolean",
                        width: 75
                    },
                    "dateModified",
                    "size"
                ]
            }
        }
    };
}]);
